import { render, staticRenderFns } from "./categoryCard.vue?vue&type=template&id=63a313fa&scoped=true"
import script from "./categoryCard.vue?vue&type=script&lang=js"
export * from "./categoryCard.vue?vue&type=script&lang=js"
import style0 from "./categoryCard.vue?vue&type=style&index=0&id=63a313fa&prod&scoped=true&lang=css"
import style1 from "./categoryCard.vue?vue&type=style&index=1&id=63a313fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a313fa",
  null
  
)

export default component.exports